<template>
  <div class="contact-cards d-flex justify-space-around mb-6">
    <v-card class="mx-auto pa-2" color="#7289DA" dark max-width="400">
      <v-card-title>
        <v-icon large left> mdi-discord </v-icon>
        <span class="title font-weight-light">Discord</span>
      </v-card-title>

      <v-card-text class="headline font-weight-bold" style="text-align: left">
        "This is the easiest and fastest way of contacting me."
      </v-card-text>

      <v-card-actions>
        <v-list-item class="grow">
          <v-list-item-avatar color="#7289DA">
            <v-img
              class="elevation-6"
              alt=""
              src="https://i.gyazo.com/3236cfe0080b1b20ad423addbf1f0dd6.jpg"
            ></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Gabriel 'GCS'#2589</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto pa-2" color="#00AFF0" dark max-width="400">
      <v-card-title>
        <v-icon large left> mdi-skype </v-icon>
        <span class="title font-weight-light">Skype</span>
      </v-card-title>

      <v-card-text class="headline font-weight-bold" style="text-align: left">
        "Sometimes you will find me here."
      </v-card-text>

      <v-card-actions>
        <v-list-item class="grow">
          <v-list-item-avatar color="#00AFF0">
            <v-img
              class="elevation-6"
              alt=""
              src="https://i.gyazo.com/3236cfe0080b1b20ad423addbf1f0dd6.jpg"
            ></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>gabriel_costa25@hotmail.com</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card-actions>
    </v-card>
    <v-card class="mx-auto pa-2" color="#3b5998" dark max-width="400">
      <v-card-title>
        <v-icon large left> mdi-facebook </v-icon>
        <span class="title font-weight-light">Facebook</span>
      </v-card-title>

      <v-card-text class="headline font-weight-bold" style="text-align: left">
        "Leave us a message and we will answer when possible."
      </v-card-text>

      <v-card-actions>
        <v-list-item class="grow">
          <v-list-item-avatar color="#3b5998">
            <v-img
              class="elevation-6"
              alt=""
              src="https://i.gyazo.com/3236cfe0080b1b20ad423addbf1f0dd6.jpg"
            ></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-btn depressed color="#3b5998" href="https://www.facebook.com/L2jgabdev" target="_blank"> @l2jgabdev </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Contact",
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
